export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7873.dfa3a0d8.jpg";